import { Fab, IconButton } from '@material-ui/core';
import styled, { css } from 'styled-components';
export var TooltippedButtonSize;
(function (TooltippedButtonSize) {
    TooltippedButtonSize["ExtraSmall"] = "ExtraSmall";
    TooltippedButtonSize["Small"] = "Small";
    TooltippedButtonSize["Medium"] = "Medium";
    TooltippedButtonSize["Large"] = "Large";
})(TooltippedButtonSize || (TooltippedButtonSize = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["ExtraSmall"] = "24px";
    ButtonSize["Small"] = "32px";
    ButtonSize["Medium"] = "40px";
    ButtonSize["Large"] = "60px";
})(ButtonSize || (ButtonSize = {}));
export var IconSize;
(function (IconSize) {
    IconSize["ExtraSmall"] = "18px";
    IconSize["Small"] = "20px";
    IconSize["Medium"] = "24px";
    IconSize["Large"] = "35px";
})(IconSize || (IconSize = {}));
const CommonButtonStyles = css `
    width: ${(props) => ButtonSize[props.$size]};
    height: ${(props) => ButtonSize[props.$size]};
    min-height: ${(props) => ButtonSize[props.$size]};
    min-width: ${(props) => ButtonSize[props.$size]};

    ${(props) => (props.disabled ? 'opacity: 0.25;' : null)}

    svg {
        color: ${(props) => props.theme.colors.primary};
        width: ${(props) => IconSize[props.$size]};
        min-width: ${(props) => IconSize[props.$size]};
        min-height: ${(props) => IconSize[props.$size]};
        height: ${(props) => IconSize[props.$size]};
    }
`;
export const FabContainer = styled(Fab) `
    ${CommonButtonStyles}

    background-color: ${(props) => props.theme.colors.surface};
`;
export const IconButtonContainer = styled(IconButton) `
    ${CommonButtonStyles}
`;
//# sourceMappingURL=TooltippedButton.js.map